import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Contacto } from 'src/app/interfaces/contacto';
import { Response } from 'src/app/interfaces/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactoService {

    private baseApiUrl = environment.baseApi + "/publico/contacto";

    constructor(private httpClient: HttpClient) { }

    enviarContacto(contacto: Contacto): Observable<Response> {
        return this.httpClient.post<Response>(`${this.baseApiUrl}/enviar`, contacto);
    }
}
